// SCR-STAFF-707 (AP-MED-03؛ US-MED-070، 072، 076): ارجاع‌های ملی و کدهای رهگیری یک مواجهه با جستجوی کد رهگیری.
// نمای کد رهگیری **عملیاتی** است (`med.national_referral.track`): فقط نوع، کد، سامانه و زمان — بدون محتوای بالینی
// (AC-MED-076.2). ثبت ارجاع، استعلام و بازخورد `med.national_referral.submit` می‌خواهند و تنها برای پزشک دیده می‌شوند.
import { useAccess } from '@phoenix/auth';
import { DetailPage, EmptyState, type DetailTab } from '@phoenix/ui';
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import {
  AdmissionOrderPanel,
  InboundNationalReferralPanel,
  NationalReferralPanel,
  SCR_STAFF_707,
  TrackingCodeSearchPanel,
} from './referralNational';

export function NationalReferralsPage() {
  const access = useAccess();
  const [params, setParams] = useSearchParams();
  const encounterId = params.get('encounterId') ?? '';
  const inboundReferralId = params.get('inboundReferralId') ?? '';
  const [tab, setTab] = useState('outgoing');
  const canSubmit = access.can('med.national_referral.submit');

  const tabs: DetailTab[] = [
    {
      id: 'outgoing',
      labelKey: 'med:referral_national.tab_outgoing',
      content: encounterId ? (
        <NationalReferralPanel encounterId={encounterId} />
      ) : (
        <EmptyState titleKey="med:referral_national.pick_encounter" />
      ),
    },
    {
      id: 'inbound',
      labelKey: 'med:referral_national.tab_inbound',
      content:
        encounterId && inboundReferralId ? (
          <InboundNationalReferralPanel encounterId={encounterId} inboundReferralId={inboundReferralId} />
        ) : (
          <EmptyState titleKey="med:referral_national.pick_inbound" />
        ),
    },
    {
      id: 'admission',
      labelKey: 'med:referral_national.tab_admission',
      content: encounterId ? (
        <AdmissionOrderPanel encounterId={encounterId} />
      ) : (
        <EmptyState titleKey="med:referral_national.pick_encounter" />
      ),
    },
    {
      id: 'codes',
      labelKey: 'med:referral_national.tab_codes',
      content: (
        <TrackingCodeSearchPanel
          encounterId={encounterId || undefined}
          onPick={(found) => setParams({ encounterId: found })}
        />
      ),
    },
  ];

  return (
    <DetailPage
      screenId={SCR_STAFF_707}
      titleKey="med:referral_national.page_title"
      subtitleKey="med:referral_national.page_subtitle"
      tabs={canSubmit ? tabs : tabs.filter((item) => item.id === 'codes')}
      activeTab={canSubmit ? tab : 'codes'}
      onTabChange={setTab}
    />
  );
}
